import { SNIPPET_REMOTE_ACTION_MAP_KEY } from 'flow/service/actionOptions';
import { ContainerType } from 'flow/store/engine/types';
import type {
  Action,
  ContainerContext,
  LegacyActionOption,
  SnippetContainerContext,
  SnippetRemoteActionMap,
} from 'flow/store/engine/types';


/**
 * Checks if an action is part of a snippet. Can be used prior to
 * forward transformation or post transformation in redux store.
 * @param action
 * @returns boolean
 */
export function isSnippetChildAction(action: Action): boolean {
  return action.containerContext?.type === ContainerType.SNIPPET
    || Boolean(action.options[SNIPPET_REMOTE_ACTION_MAP_KEY]?.jsonValue);
}

/**
 * Type guard to check if the jsonValue is a valid SnippetRemoteActionMap.
 * @param jsonValue
 * @returns boolean
 */
export function isValidSnippetRemoteActionMap(jsonValue: any): jsonValue is SnippetRemoteActionMap {
  return typeof jsonValue === 'object'
    && jsonValue !== null
    && !Array.isArray(jsonValue);
}

export function createContainerContextForAction(args: {
  actionOptions: LegacyActionOption[];
}): ContainerContext {
  const { actionOptions } = args;
  const snippetRemoteActionMapOption = actionOptions
    .find(ao => ao.key === SNIPPET_REMOTE_ACTION_MAP_KEY);

  if (!snippetRemoteActionMapOption) {
    throw new Error('Missing required action option for container context');
  }

  if (!isValidSnippetRemoteActionMap(snippetRemoteActionMapOption.jsonValue)) {
    throw new Error('Invalid jsonValue for snippet remote action map');
  }

  return {
    type: ContainerType.SNIPPET,
    actionOptionPublicId: snippetRemoteActionMapOption.publicId,
    snippetRemoteActionMap: snippetRemoteActionMapOption.jsonValue,
  };
}

/** Returns the first parent snippet id */
export function getFirstSnippetParentId(context: SnippetContainerContext) {
  return Object.keys(context.snippetRemoteActionMap)[0];
}
